import React, { useState,useEffect, useRef } from 'react'
import { useTranslation } from "react-i18next";

import { Button } from "primereact/button";
import { Dialog } from 'primereact/dialog';

        
const PrimeDialog = ({
    visible=false,
    onConfirm, onClose,onDelete,
    isShowDelBtn=false,
    title = 'Dialog',
    draggable = false,
    bodyTemplate,
    cancelLabel="button.cancel",
    confirmLabel="button.confirm",
    deleteLabel="button.delete",
    className,
    style={},
    size='md',
    contentStyle={},
    position='center',
    disabledConfirm=false,
    scrollByBody = false,
    loading,
    isShowConfBtn = true,
    isShowCancelBtn = true,
    resizable = false
}) =>{
    const { t } = useTranslation();
    const handleConfirm = () => {
        onConfirm();
    }
    const [sizeNum, setSizeNum]=useState('')


    const handleCancel = () => {
        onClose();
    }

    const handleDelete = ()=>{
        onDelete()
    }

    const footerContent = (
        <div>
            <Button style={{display:isShowConfBtn?'':'none'}} loading={loading} disabled={disabledConfirm} onClick={handleConfirm} label={t(confirmLabel)} icon="pi pi-check" size='small' />
            <Button onClick={handleCancel} style={{display:isShowCancelBtn?'':'none'}} label={t(cancelLabel)} icon="pi pi-times" size='small' outlined />
            <Button severity="danger" style={{display:isShowDelBtn?'':'none'}} onClick={handleDelete} label={t(deleteLabel)} icon="pi pi-check" size='small'/>
        </div>
    );
    useEffect(()=>{
        switch (size) {
            case 'lg':
                setSizeNum('75vw')
                break;
            case 'md':
                setSizeNum('50vw')
                break;
            case 'sm':
                setSizeNum('30vw')
                break;
        
            default:
                setSizeNum('50vw')
                break;
        }
    },[size])


    return (
      <Dialog
        header={title}
        visible={visible}
        onHide={handleCancel}
        footer={footerContent}
        draggable={draggable}
        resizable={resizable}
        children={bodyTemplate}
        style={{ ...style, width: `${sizeNum}` }}
        breakpoints={{ "991px": "95vw" }}
        className={className}
        position={position}
        maskClassName="prime-dialog-zindex"
        maskStyle={scrollByBody ? { overflow: "auto", alignItems: "flex-start" } : {}}
        contentStyle={{ ...(scrollByBody ? { overflow: "inherit" } : ""), ...contentStyle }}
      ></Dialog>
    );
}
export default PrimeDialog;